import React, { useState } from 'react';
import {
  Box,
  Typography,
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import { UserPromptCard } from './UserPromptCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
    },
    title: {
      fontSize: '20px',
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    breadcrumb: {
      fontSize: '14px',
      color: theme.palette.text.secondary,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '6px',
    },
    mostFrequent: {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: '8px',
      padding: '16px',
    },
    frequentTitle: {
      fontSize: '14px',
      fontWeight: 600,
      color: '#0066CC',
      marginBottom: '12px',
    },
    promptList: {
      paddingLeft: '20px',
      margin: 0,
      '& li': {
        fontSize: '14px',
        color: theme.palette.text.primary,
        lineHeight: '20px',
        marginBottom: '8px',
        '&:last-child': {
          marginBottom: 0,
        },
      },
    },
    userCards: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
  }),
);

export interface UserPrompt {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  initials: string;
  date: string;
  product: string;
  prompts: string[];
}

export interface UserPromptListProps {
  totalCount: number;
  domain: string;
  subDomain: string;
  persona: string;
  mostFrequentPrompts: string[];
  users: UserPrompt[];
  className?: string;
}

export const UserPromptList: React.FC<UserPromptListProps> = ({
  totalCount,
  domain,
  subDomain,
  persona,
  mostFrequentPrompts,
  users,
  className = '',
}) => {
  const classes = useStyles();

  return (
    <Box className={`${classes.container} ${className}`}>
      <Box className={classes.header}>
        <Typography className={classes.title}>
          User Prompts ({totalCount})
        </Typography>
        <Typography className={classes.breadcrumb}>
          <span>Domain: {domain}</span>
          <span>•</span>
          <span>Sub-domain: {subDomain}</span>
          <span>•</span>
          <span>Persona: {persona}</span>
        </Typography>
      </Box>

      <Box className={classes.mostFrequent}>
        <Typography className={classes.frequentTitle}>
          Most Frequently used
        </Typography>
        <ul className={classes.promptList}>
          {(mostFrequentPrompts ?? []).map((prompt, index) => (
            <li key={index}>{prompt || 'No prompt text'}</li>
          ))}
        </ul>
      </Box>

      <Box className={classes.userCards}>
        {(users ?? []).map((user) => (
          <UserPromptCard key={user.id} {...user} />
        ))}
      </Box>
    </Box>
  );
};
